var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("portal", [
    _c("div", { staticClass: "dgov2-popup" }, [
      _c("div", { staticClass: "dgov2-popup-screen" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "dgov2-popup-container", style: _vm.containerStyles },
        [
          _c(
            "div",
            {
              staticClass: "dgov2-popup-close",
              on: { click: _vm.handleClose },
            },
            [_c("i", { staticClass: "fas fa-times" })]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dgov2-popup-contents",
              attrs: { "data-media-id": "pop" },
            },
            [
              _c(
                "div",
                { staticClass: "dgov2-popup-media", style: _vm.mediaStyles },
                [
                  _vm.slideshowOn
                    ? _c(
                        "slick-slide-show",
                        {
                          ref: "slickSlideshow",
                          attrs: {
                            uniqueId: _vm.options.moduleId,
                            initialSlide: _vm.options.initialSlide,
                            onSlideChange: _vm.onSlideChange,
                            mediaHeight: _vm.mediaHeight,
                          },
                        },
                        _vm._l(_vm.options.slides, function (slide) {
                          return _c("cropzoomImg", {
                            key: slide.title,
                            ref: "imgs",
                            refInFor: true,
                            attrs: {
                              alt: slide.alt,
                              debug: true,
                              src: slide.imageUrl,
                              title: slide.title,
                              "aspect-ratio": _vm.mediaAspectRatio,
                              slide: slide,
                              portalId: _vm.options.portalId,
                            },
                          })
                        }),
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dgov2-popup-info",
                  style: _vm.infoStyles,
                  on: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k(
                          $event.keyCode,
                          "escape",
                          undefined,
                          $event.key,
                          undefined
                        )
                      ) {
                        return null
                      }
                      return _vm.onEscape.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "dgov2-popup-info-caption" }, [
                    _c("strong", { staticClass: "slide-count" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.slideNumber) +
                          "/" +
                          _vm._s(_vm.numSlides) +
                          "\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "slide-info-separator" }, [
                      _vm._v(
                        "\n                            -\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.slideTitle
                      ? _c("span", { staticClass: "slide-info-title" }, [
                          _c("span", { staticClass: "slide-title" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.slideTitle) +
                                "\n                            "
                            ),
                          ]),
                          _vm._v(
                            "\n                            -\n                        "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "slide-caption" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.slideCaption) +
                          "\n                        "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "dgov2-popup-info-bottom" }, [
                    _c("div", { staticClass: "bottom-content" }, [
                      _c("div", { staticClass: "social" }, [
                        _c("span", { staticClass: "subhead" }, [
                          _vm._v("Share:"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "social-inner" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "a2a_kit a2a_default_style social-inner",
                              attrs: {
                                "data-a2a-url": _vm.shareUrl,
                                "data-a2a-title": _vm.slideTitle,
                              },
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "a2a_button_facebook social-link",
                                  attrs: { "aria-label": "Share to Facebook" },
                                },
                                [_c("span", { staticClass: "fa fa-facebook" })]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "a2a_button_x social-link",
                                  attrs: { "aria-label": "Share to X" },
                                },
                                [
                                  _c("span", {
                                    staticClass: "fa-brands fa-x-twitter",
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "social-link social-link-more",
                              attrs: {
                                tabindex: "0",
                                "aria-haspopup": "true",
                                onclick:
                                  "dgov2ss_handleSocialLinkMoreClick(event)",
                              },
                            },
                            [
                              _c("span", { staticClass: "fas fa-share" }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "more-share more-share-dark" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "social-link-more-close" },
                                    [_vm._v("×")]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "title" }, [
                                    _vm._v("Share"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "social-link-link social-link",
                                      attrs: {
                                        "data-url": _vm.shareUrl,
                                        href: "javascript:void(0)",
                                        onclick:
                                          "dgov2ss_handleCopyLinkClick(event)",
                                        rel: "noreferrer noopener",
                                        tabindex: "0",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "social-link-inner" },
                                        [
                                          _c("span", {
                                            staticClass: "fa fa-link",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "b",
                                            { staticClass: "copy-link-text" },
                                            [_vm._v("Copy Link")]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "a2a_kit a2a_default_style",
                                      attrs: {
                                        "data-a2a-url": _vm.shareUrl,
                                        "data-a2a-title": _vm.slideTitle,
                                      },
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "a2a_button_email social-link",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "social-link-inner",
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "fa fa-envelope",
                                              }),
                                              _vm._v(
                                                " Email\n                                                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "a2a_button_facebook social-link",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "social-link-inner",
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "fa fa-facebook",
                                              }),
                                              _vm._v(
                                                " Facebook\n                                                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "a2a_button_x social-link",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "social-link-inner",
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "fa-brands fa-x-twitter",
                                              }),
                                              _vm._v(
                                                " X\n                                                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "a2a_button_linkedin social-link",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "social-link-inner",
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "fa fa-linkedin",
                                              }),
                                              _vm._v(
                                                " LinkedIn\n                                                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "a2a_button_whatsapp social-link",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "social-link-inner last",
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "fa fa-whatsapp",
                                              }),
                                              _vm._v(
                                                " WhatsApp\n                                                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "action" }, [
                        false
                          ? _c("div", { staticClass: "title" }, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.slideTitle) +
                                  "\n                                "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isVideo
                          ? _c(
                              "div",
                              { staticClass: "action-item download-link" },
                              [
                                _c("span", [_vm._v("Download:")]),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "action-frame article-link",
                                    attrs: {
                                      href: _vm.hiresUrl,
                                      title: _vm.slideTitle,
                                      target: "_blank",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        Full Size (" +
                                        _vm._s(_vm.fileSize) +
                                        ")\n                                    "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.photographer
                          ? _c(
                              "div",
                              { staticClass: "action-item photographer" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "action-item action-frame" },
                                  [
                                    _c("span", [_vm._v("Credit:")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.photographer) +
                                        "\n                                    "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.virin
                          ? _c("div", { staticClass: "action-item virin" }, [
                              _c(
                                "div",
                                { staticClass: "action-item action-frame" },
                                [
                                  _c("span", { staticClass: "virin-value" }, [
                                    _vm._v("VIRIN:"),
                                  ]),
                                  _vm._v(
                                    _vm._s(_vm.virin) +
                                      "\n                                    "
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }